// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
 * React Search App - Uses Tailwind CSS
 * This file is kept minimal - all styles should use Tailwind utility classes
 */
`, "",{"version":3,"sources":["webpack://./src/app/index.css"],"names":[],"mappings":"AAAA;;;EAGE","sourcesContent":["/* \n * React Search App - Uses Tailwind CSS\n * This file is kept minimal - all styles should use Tailwind utility classes\n */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
